/* HB Kit Upsell — variant resolution + AJAX add-to-cart (2026-08-10).
   External asset because inline section scripts are suppressed on templates
   carrying the Shogun optimizer section. */
(function () {
  function init() {
    window.__hbKitUpsell = 'executed';
    var root = document.querySelector('.hb-kit-upsell');
    if (!root || root.dataset.hbKitInit) return;
    root.dataset.hbKitInit = '1';
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-kit-opt]'));
    var jsonEl = root.querySelector('[data-kit-variants]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var atc = root.querySelector('[data-kit-atc]');
    var atcLabel = atc.querySelector('span');
    var atcPrice = root.querySelector('[data-kit-atc-price]');
    var bigPrice = root.querySelector('[data-kit-price]');
    var kitUrl = atc.getAttribute('data-kit-url');
    var current = null;

    function resolve() {
      if (!selects.length) {
        // single-variant kit: no option selects rendered
        current = variants[0] || null;
      } else {
        var chosen = selects.map(function (s) { return s.value; });
        current = null;
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < chosen.length; j++) {
            if (variants[i].options[j] !== chosen[j]) { match = false; break; }
          }
          if (match) { current = variants[i]; break; }
        }
      }
      var ok = !!(current && current.available);
      // variant image swap (per-variant media, embedded as [700w, 1000w, 1400w])
      var img = root.querySelector('.hb-kit-upsell__imgwrap img');
      if (img && current && current.img && img.getAttribute('src') !== current.img[1]) {
        img.setAttribute('src', current.img[1]);
        img.setAttribute('srcset', current.img[0] + ' 700w, ' + current.img[1] + ' 1000w, ' + current.img[2] + ' 1400w');
        img.style.objectFit = current.imgSq ? 'cover' : 'contain';
      }
      atc.disabled = !ok;
      atcLabel.textContent = ok ? 'Add Kit to Cart' : 'Unavailable';
      if (ok) {
        if (atcPrice) atcPrice.innerHTML = '&nbsp;— ' + current.price;
        if (bigPrice) bigPrice.textContent = current.price;
      } else if (atcPrice) {
        atcPrice.innerHTML = '';
      }
    }

    selects.forEach(function (s) { s.onchange = resolve; });
    resolve();

    atc.onclick = function () {
      if (!current || !current.available) return;
      atc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: current.id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (item) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        atc.disabled = false;
      }).catch(function () {
        atc.disabled = false;
        if (kitUrl) window.location.href = kitUrl;
      });
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
